export default "__VITE_ASSET__9683bcf0__"